import { BaseInput } from './base-input';

export class CheckboxInput extends BaseInput {
  public constructor(data: any) {
    super(data);
  }
}
